module.exports = __webpack_public_path__ + "assets/minus_grey-db12fc.svg";